import { Fragment } from "react";

import { Link } from "react-router-dom";
import { Typography } from "@mui/material";

import { type RowItem } from "../InvoiceDetails/invoiceRow";
import { type Invoice } from "../types";
import { isLinkedInvoiceNotCanceled } from "./utils";

export const LinkedFeeInvoices = ({ invoiceData, invoices }: { invoiceData: RowItem; invoices: Invoice[] }) => {
  const entityId = invoiceData.entity?.id;

  const paymentIntents = invoiceData.stripePaymentIntents?.filter((paymentIntent) =>
    isLinkedInvoiceNotCanceled(paymentIntent, invoices)
  );

  if (!paymentIntents?.length) {
    return "N/A";
  }

  const links = paymentIntents.map((paymentIntent, index) => (
    <Fragment key={paymentIntent?.linked_invoice?.invoice_id}>
      <Typography
        component={Link}
        to={`${location.pathname}/${entityId}/${paymentIntent?.linked_invoice?.invoice_id}`}
        color="inherit"
        variant="body2"
        style={{ cursor: "pointer" }}
      >
        {paymentIntent?.linked_invoice?.invoice_id}
      </Typography>
      {index < paymentIntents.length - 1 && (
        <Typography component="span" color="inherit" variant="body2">
          ,{" "}
        </Typography>
      )}
    </Fragment>
  ));

  return <>{links}</>;
};
